import { ViewportType } from '../../../enums';
import { getVideoProjectionPresentation, withVideoProjectionPresentation, } from './videoProjectionPresentation';
import { getVideoProjectionSnapshot } from './videoProjectionSnapshot';
import { VIDEO_PROJECTION_ID, } from './VideoProjectionTypes';
export { getVideoProjectionSnapshot };
export const videoProjectionAdapter = {
    id: VIDEO_PROJECTION_ID,
    viewportTypes: [ViewportType.VIDEO_NEXT],
    getSnapshot: (request) => getVideoProjectionSnapshot(request),
    getPresentation: (snapshot, selector) => getVideoProjectionPresentation(snapshot, selector),
    withPresentation: (snapshot, presentation, options) => withVideoProjectionPresentation(snapshot, presentation, options),
};
